import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addSGPI,
  addSGPITransaction,
  getSGPIBalanceList,
  getSGPILists,
  getSGPIStatus,
  getTransactionList,
  updateSGPI,
  updateSGPITransaction,
} from "./SGPIRepository";
import { showToast } from "../../../utils/toastUtils";

export const useSGPILists = ({
  params,
  enable = false,
}: {
  params?: Record<string, any>;
  enable?: boolean;
}) => {
  return useQuery({
    queryKey: ["SGPI_LISTS", params],
    queryFn: () => getSGPILists(params),
    enabled: enable,
    retry: false,
  });
};

export const useTransactionList = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["SGPI_TRANSACTION_LIST", params],
    queryFn: () => getTransactionList(params),
    enabled: enable,
    retry: false,
  });
};

export const useSGPIBalanceList = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["SGPI_BALANCE_LIST", params],
    queryFn: () => getSGPIBalanceList(params),
    enabled: enable,
    retry: false,
  });
};

export const useGetSGPIStatus = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["SGPI_BALANCE_LIST"],
    queryFn: getSGPIStatus,
    enabled: enable,
    retry: false,
  });
};

export const useAddSGPITransaction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body: any }) => addSGPITransaction(body),
    onSuccess: (data) => {
      showToast.success("SGPI Transaction Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["SGPI_TRANSACTION_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add SGPI Transaction!");
    },
  });
};

// addSGPI
export const useAddSGPI = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body: any }) => addSGPI(body),

    onSuccess: (data) => {
      showToast.success("Add SGPI Successfully!!");
      queryClient.invalidateQueries({ queryKey: ["SGPI_LISTS"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add SGPI!");
    },
  });
};

// updateSGPITransaction

export const useUpdateSGPITransaction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string | number; body: any }) =>
      updateSGPITransaction(id, body),

    onSuccess: (data) => {
      showToast.success("Update SGPI Transaction Successfully!!");
      queryClient.invalidateQueries({ queryKey: ["SGPI_TRANSACTION_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Update SGPI Transaction!");
    },
  });
};

//updateSGPI
export const useUpdateSGPI = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string | number; body: any }) =>
      updateSGPI(id, body),

    onSuccess: (data) => {
      showToast.success("Update SGPI Successfully!!");
      queryClient.invalidateQueries({ queryKey: ["SGPI_LISTS"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Update SGPI!");
    },
  });
};
